import { IEjectionReport } from "../../../../types/api";

export const getNameOfEjected = (report: IEjectionReport) => {
    return report.firstName
        ? report.lastName
            ? `${report.firstName} ${report.lastName}`
            : report.firstName
        : report.lastName || "";
};
